import "./Loader.css";

const Loader = ({
  loading = true,
  type = "spinner",
  text = "",
  overlay = false,
  size = "md",
}) => {
  if (!loading) return null;

  return (
    <div className={overlay ? "loader-overlay" : "loader-wrapper"}>
      {type === "spinner" && <div className={`loader-spinner ${size}`}></div>}

      {type === "dots" && (
        <div className="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}

      {/* {text && <p className="loader-text">{text}</p>} */}
    </div>
  );
};

export default Loader;
